import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import classNames from 'classnames';

import CLASSES_SIDEBAR_DATA from 'data/classesSidebarData';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import NavBar from 'components/NavBar';
import styles from './ClassesSidebar.module.scss';
import WithPermissions from 'components/WithPermissions';

export default function ClassesSidebar() {
  return (
    <>
      <NavBar
        title="CLASSROOM CREATION TOOL"
        className="p-xs"
        id="classes-sidebar"
      />
      <ElementSpacePlaceholder elementId="classes-sidebar" />
      <div className={styles.root}>
        {CLASSES_SIDEBAR_DATA.map((data, sectionIndex) => (
          <div
            className={styles.section}
            key={sectionIndex}
          >
            <div
              className={classNames('bold', 'dark', styles.header)}
              key={sectionIndex}
            >
              {data.header}
            </div>
            <div className={styles.tabs}>
              {data.tabs.map((tab, tabIndex) => (
                <WithPermissions
                  key={tabIndex}
                  subject={tab.subject}
                  permissions={tab.permissions}
                >
                  <NavLink
                    to={tab.to}
                    tabIndex={tabIndex}
                    className={({ isActive }) =>
                      classNames(styles.tab, { [styles.tabActive]: isActive })
                    }
                  >
                    {tab.tabName}
                  </NavLink>
                </WithPermissions>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.page}>
        <Outlet />
      </div>
    </>
  );
}
